/**
 * @deprecated Use ComboboxFieldComponent instead
 */
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatSelect, MatSelectChange } from "@angular/material/select";
import { ISimpleSelectFieldConfig } from './simple-select.interface';

@Component({
    selector: 'simple-select',
    template: `
        <form-field [formGroup]="fieldConfig?.formGroup"
                    [options]="fieldConfig"
                    [attr.class]="fieldConfig?.className"
                    [class.with-border]="withBorder"
                    [class.with-grey-label]="fieldConfig.withGreyLabel"
                    [isFull]="isFull">
            <mat-form-field class="field" [class.full]="isFull">
                
                <mat-label *ngIf="showLabelInPlaceholder">{{ label }}</mat-label>
                <mat-select [value]="fieldConfig.formGroup.controls[fieldConfig.formControlName].value"
                            [disabled]="fieldConfig.disabled"
                            [disableOptionCentering]="true"
                            (focusin)="openPanel()"
                            (selectionChange)="selectValue($event)"
                            (openedChange)="panelChange($event)"
                            #select>
                    <mat-option *ngFor="let option of fieldConfig.options"
                                [value]="option.value">
                        {{option.label}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </form-field>
    `,
    styleUrls: ["../../../../../styles/angular-material/simple-select.scss","./simple-select.component.scss"],
})

export class SimpleSelectComponent implements OnChanges {
    @Input()
    public showLabelInPlaceholder: boolean = true;
    @Input()
    public fieldConfig: ISimpleSelectFieldConfig;
    @Input()
    public forceBlur: boolean;
    @Input()
    public keepFocus: boolean;
    @Input()
    public label: string = '';
    @Input()
    public disableKeysWhenClosed: boolean;
    @Input()
    public withBorder: boolean = false;
    @Input()
    public isFull: boolean = false;
    @Input()
    public isEditable: boolean = true;

    public forceFocusValue: boolean;

    @Input()
    public get forceFocus(): boolean {
        return this.forceFocusValue;
    }

    public set forceFocus(value: boolean) {
        this.forceFocusValue = value;
        this.forceFocusChange.emit(this.forceFocusValue);
    }

    @Output()
    public readonly forceFocusChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Output()
    public readonly focus: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Output()
    public readonly blur: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output()
    public readonly onOpenedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    @ViewChild('select')
    public select: MatSelect;

    public isOpened: boolean;

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.forceFocus && changes.forceFocus.currentValue) {
            this.select.focus();
            setTimeout(() => this.forceFocusChange.emit(false));
        }

        if (this.forceBlur) {
            this.select.close();
            this.blur.emit(true);
        }
        if(changes.fieldConfig && changes.fieldConfig.currentValue){
            if(this.fieldConfig.disabled){
                this.fieldConfig.formGroup.disable({emitEvent: false});
            }else{
                this.fieldConfig.formGroup.enable({emitEvent: false});
            }
        }
        if(changes.isEditable){
            this.fieldConfig.disabled = !this.isEditable;
        }
    }

    public openPanel(): void {
        this.select.open();
        this.focus.emit(true);
    }

    public selectValue(selectChange: MatSelectChange): void {
        this.isOpened = false;
        this.fieldConfig.formGroup.get(this.fieldConfig.formControlName).patchValue(selectChange.value);
        this.select.close();
        this.blur.emit(selectChange.value);
    }

    public panelChange(open: boolean): void {
        this.isOpened = open;
        this.onOpenedChange.emit(open);
    }

    public inputBlur(): void {
        this.blur.emit(true);
    }
}
